
import { Component } from '@angular/core';
import { ListCardsUserComponent } from "../../../../shared/components/metodos-pagos/components/mercado-pago/components/list-cards-user/list-cards-user.component";

@Component({
  selector: 'perfil-user-pages-payments',
  imports: [ListCardsUserComponent],
  templateUrl: './payments.component.html',
  styleUrl: './payments.component.css'
})
export class PaymentsComponent {

}
